import { axiosDS } from '@pp/axios'
import { urls } from 'Src/constants/Urls'
import { RequestParams } from 'Models'
import { AnswerModel } from 'Pages/survey'

export const answersApi = {
	getAll: async (id: number, params?: RequestParams) => {
		const res = await axiosDS().get<AnswerModel>(`${urls.survey.base}/${id}/answer/`, { params })
		return res.data
	},
	getOne: async (id: number) => {
		const res = await axiosDS().get<AnswerModel>(`${urls.survey.answer}/${id}`)
		return res.data
	},
	createOne: async (attempt_id: number, question_id: number, data: AnswerModel) => {
		const formData = new FormData()
		if (data.attachments_attributes) {
			// @ts-ignore
			formData.append('data[attachments_attributes][][file]', data.attachments_attributes)
		}
		const res = await axiosDS().post<AnswerModel>(
			`${urls.survey.attempt}/${attempt_id}/question/${question_id}/answer`,
			data.attachments_attributes ? formData : { data }
		)
		return res.data
	},
	updateOne: async (id: number, data: AnswerModel) => {
		const formData = new FormData()
		if (data.attachments_attributes) {
			// @ts-ignore
			formData.append('data[attachments_attributes][][file]', data.attachments_attributes)
		}
		const res = await axiosDS().patch<AnswerModel>(
			`${urls.survey.answer}/${id}`,
			data.attachments_attributes ? formData : { data }
		)
		return res.data
	},
	deleteOne: async (id: number) => {
		const res = await axiosDS().delete(`${urls.survey.answer}/${id}`)
		return res.data
	},
}
